import React from 'react';

const Satellite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="satellite_icon"
    viewBox="0 0 54 56"
  >
    <g fill="none" fillRule="evenodd" strokeWidth="1.6">
      <path
        stroke="#FFF"
        d="M48.26 17.454l-16.134 17.89-13.891-12.656 16.133-17.89z"
      />
      <path
        stroke="#FFF"
        d="M18.07 32.576l-5.029-4.582c2.642-1.875 7.603-2.622 11.61.556 4.062 3.223 4.764 8.646 2.731 12.508l-5.028-4.583-.002.002"
      />
      <path
        stroke="#67D3DF"
        d="M26.107 52.184c-4.266 3.026-12.274 4.232-18.743-.9-6.56-5.202-7.694-13.958-4.41-20.191"
      />
      <path
        stroke="#67D3DF"
        d="M23.233 46.978c-2.727 1.935-7.85 2.706-11.986-.575-4.195-3.328-4.92-8.928-2.82-12.915"
      />
      <path
        stroke="#67D3DF"
        d="M19.785 42.026c-1.186.842-3.414 1.177-5.212-.25-1.825-1.447-2.14-3.883-1.227-5.615"
      />
      <path
        stroke="#FFF"
        d="M47.19 22.761l5.513 5.024-9.916 10.995-5.513-5.023M19.173 17.263l-5.512-5.023 9.914-10.996 5.515 5.023M27.156 40.854l-14.115-12.86"
      />
    </g>
  </svg>
);

export default Satellite;
